import Gooey, { mount, model, calc, dynGet } from '@srhazi/gooey';
import { UiComponent } from './components/ui-component';
import { MarqueeButton } from './components/marquee-button';
import { MarqueePane } from './components/marquee-pane';
import { BubbleText } from './components/bubble-text';
import { NumberInput } from './components/number-input';
import { AutoSizedText } from './components/auto-sized-text';
import { Fixture } from './components/fixture';
import './components.css';

mount(
    document.getElementById('main')!,
    <>
        <UiComponent
            name="MarqueePane"
            description="A large button which transitions to a set of animated marquees overlayed at an angle when activated"
        >
            <Fixture
                Component={MarqueePane}
                propDefs={
                    {
                        children: ['children', 'Just the right stuff', {}],
                        width: ['number', 200, {}],
                        height: ['number', 200, {}],
                        gapX: ['number', 10, { min: 0 }],
                        gapY: ['number', 10, { min: 0 }],
                        scrollEven: ['number', 52, {}],
                        scrollOdd: ['number', -40, {}],
                        angle: [
                            'number',
                            Math.PI / 6,
                            {
                                type: 'range',
                                min: 0,
                                max: Math.PI * 2,
                                step: (Math.PI * 2) / 360,
                            },
                        ],
                    } as const
                }
            />
        </UiComponent>
        <UiComponent
            name="MarqueeButton"
            description="A large button which transitions to a set of animated marquees overlayed at an angle when activated"
        >
            <Fixture
                Component={MarqueeButton}
                propDefs={
                    {
                        label: ['string', 'ACCEPT', {}],
                        width: ['number', 200, {}],
                        height: ['number', 200, {}],
                        gapX: ['number', 10, { min: 0 }],
                        gapY: ['number', 10, { min: 0 }],
                        scrollEven: ['number', 52, {}],
                        scrollOdd: ['number', -40, {}],
                        angle: [
                            'number',
                            Math.PI / 6,
                            {
                                type: 'range',
                                min: 0,
                                max: Math.PI * 2,
                                step: (Math.PI * 2) / 360,
                            },
                        ],
                        forceActive: ['boolean', false, {}],
                    } as const
                }
            />
        </UiComponent>
        <UiComponent
            name="BubbleText"
            description="A span of text where each letter dynamically reacts to the cursor position"
        >
            <Fixture
                Component={(props) => (
                    <>
                        <h1>
                            <BubbleText {...props} />
                        </h1>
                        <h2>
                            <BubbleText {...props} />
                        </h2>
                        <h3>
                            <BubbleText {...props} />
                        </h3>
                        <h4>
                            <BubbleText {...props} />
                        </h4>
                        <h5>
                            <BubbleText {...props} />
                        </h5>
                        <h6>
                            <BubbleText {...props} />
                        </h6>
                        <p>
                            <BubbleText {...props} />
                        </p>
                    </>
                )}
                propDefs={
                    {
                        label: ['string', 'Hello there', {}],
                        minFontWidth: ['number', 75, {}],
                        maxFontWidth: ['number', 100, {}],
                    } as const
                }
            />
        </UiComponent>
        <UiComponent
            name="AutoSizedText"
            description="A piece of text that attempts to fit to the target width by adjusting the font-width variable font property"
        >
            <Fixture
                Component={(props) => (
                    <div
                        style={calc(
                            () =>
                                `width: ${dynGet(
                                    props.width
                                )}px; background-color: rgba(255,0,0,0.2);`
                        )}
                    >
                        <h1>
                            <AutoSizedText {...props} />
                        </h1>
                        <h2>
                            <AutoSizedText {...props} />
                        </h2>
                        <h3>
                            <AutoSizedText {...props} />
                        </h3>
                        <h4>
                            <AutoSizedText {...props} />
                        </h4>
                        <h5>
                            <AutoSizedText {...props} />
                        </h5>
                        <h6>
                            <AutoSizedText {...props} />
                        </h6>
                        <p>
                            <AutoSizedText {...props} />
                        </p>
                    </div>
                )}
                propDefs={{
                    label: ['string', 'Welcome', {}],
                    width: [
                        'number',
                        100,
                        { min: 0, max: 1000, type: 'range' },
                    ],
                    fontWidth: ['number', 85, { min: 75, max: 100 }],
                    fontWidthMin: ['number', 75, { min: 75, max: 100 }],
                    fontWidthMax: ['number', 100, { min: 75, max: 100 }],
                    letterSpacing: [
                        'number',
                        0,
                        { min: -10, max: 10, step: 0.1 },
                    ],
                    letterSpacingMin: [
                        'number',
                        -10,
                        { min: -10, max: 10, step: 0.1 },
                    ],
                    letterSpacingMax: [
                        'number',
                        100,
                        { min: -10, max: 100, step: 0.1 },
                    ],
                }}
            />
        </UiComponent>
    </>
);
